<template>
    <div>
        <card class="sidebar-steps rounded-lg pt-7 hidden md:block">
            <h4 class="title">{{ title }}</h4>
            <ul class="steps-container">
                <li
                    @click="stepClicked(step)"
                    class="step-item"
                    :class="[{'step-active': step.active && !step.complete}, {'step-complete pointer': step.complete }]"
                    v-for="step in filteredSteps"
                    :key="step.id"
                >
                    <div class="step-item-title" :class="{'font-bold': step.active && !step.complete}">
                        <span>{{ step.title }}</span>
                    </div>
                    <div class="step-item-status" v-if="step.active && step.status">
                        <span>{{ step.status }}</span>
                    </div>
                </li>
            </ul>
        </card>
    </div>
</template>

<script>
import Card from '@/online_booking/new/components/common/Card';
import { mapActions, mapGetters } from 'vuex';

export default {
    props: {
        title: {
            type: String,
            default: ''
        },
    },
    computed: {
        ...mapGetters('OnlineBooking', ['totalStepCount', 'filteredSteps']),
    },
    methods: {
        ...mapActions('OnlineBooking', ['setCurrentStep']),

        stepClicked (step) {
            if (!step.complete) {
                return
            }

            // Courses information page works differently than other pages in client universe.
            if (step.id === 'courseInfo') {
                this.$router.push({
                    name: 'online-course',
                    params: {
                        slug: this.$route.params.slug
                    }
                });
                return;
            }

            // Subscription information page works differently than other pages in client universe.
            if (step.id === 'subscriptionInfo') {
                this.$router.push({
                    name: 'membership-plan',
                    params: {
                        slug: this.$route.params.slug
                    }
                })
            }

            this.setCurrentStep(step.id);
        }
    },

    components: {
        Card,
    },
}
</script>
